import { getScrollParent } from '../../../core/dom/getScrollParent.ts';

/**
 * Porta l'inizio della card al bordo superiore dello scroll container: la
 * barra di subentro (`ConfigurationCardDenseNav`) ne copre l'header mostrando
 * lo stesso titolo. Lo scroll parent è ricavato dalla card stessa, così la
 * funzione è usabile anche da fuori il container (es. menu nell'header del
 * Drawer).
 */
export function scrollToConfigurationCard(id: string): void {
  const el = document.getElementById(id);
  // Senza card nel DOM o scroll parent non c'è dove/cosa scrollare.
  if (!el) return;
  const scrollParent = getScrollParent(el);
  if (!scrollParent) return;
  // scrollTop attuale + distanza della card dal top del container.
  const target =
    scrollParent.scrollTop +
    (el.getBoundingClientRect().top - scrollParent.getBoundingClientRect().top);
  // `Math.max(0, …)`: non si scrolla oltre l'inizio del contenuto.
  scrollParent.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
}
